import { Fetcher } from '@this/src/util';

export type SearchItem = {
  item_type: string;
  pair?: string;
  origin?: string;
  destination?: string;
  outdate?: string;
  outhour?: string;
  outmin?: string;
  outtype?: string;
  homedate?: string;
  homehour?: string;
  homemin?: string;
  hometype?: string;
  checkin_date?: string;
  checkout_date?: string;
  destination_address?: string;
};

type ConversationStateResponse = {
  current_search_params: {
    items?: Record<string, SearchItem>;
    search_targets?: string[];
  };
  missing_fields: string[];
  date_validation_errors: string[];
  search_targets: string[];
  ready_to_search: boolean;
  updated_at: string | null;
};

export type ConversationState = {
  currentSearchParams: {
    items?: Record<string, SearchItem>;
    searchTargets?: string[];
  };
  missingFields: string[];
  dateValidationErrors: string[];
  searchTargets: string[];
  readyToSearch: boolean;
  updatedAt: string | null;
};

const toConversationState = (response: ConversationStateResponse): ConversationState => ({
  currentSearchParams: {
    items: response.current_search_params?.items,
    searchTargets: response.current_search_params?.search_targets
  },
  missingFields: response.missing_fields,
  dateValidationErrors: response.date_validation_errors,
  searchTargets: response.search_targets,
  readyToSearch: response.ready_to_search,
  updatedAt: response.updated_at
});

export const fetchConversationState = async (tripId: string): Promise<ConversationState> => {
  const response = await Fetcher.get<ConversationStateResponse>(`/trips/${tripId}/ai_conversation_state`);
  return toConversationState(response);
};
